import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/** `eventName` matches the `type` of the actions dispatched by `fetchFacilities`/`createFacility`/`updateFacility`/`deleteFacility`. */
const FacilitiesNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="FACILITY_CREATED"
				title="Agence créée"
				message="L’agence a bien été créée."
			/>
			<SuccessNotification
				eventName="FACILITY_UPDATED"
				title="Agence modifiée"
				message="L’agence a bien été modifiée."
			/>
			<SuccessNotification
				eventName="FACILITY_DELETED"
				title="Agence supprimée"
				message="L’agence a bien été supprimée."
			/>
			<ErrorNotification
				eventName="FACILITY_CREATION_FAILED"
				title="Erreur"
				message="L’agence n’a pas pu être créée."
			/>
			<ErrorNotification
				eventName="FACILITY_UPDATE_FAILED"
				title="Erreur"
				message="L’agence n’a pas pu être modifiée."
			/>
			<ErrorNotification
				eventName="FACILITY_DELETION_FAILED"
				title="Erreur"
				message="L’agence n’a pas pu être supprimée."
			/>
			<ErrorNotification
				eventName="FACILITIES_FETCH_FAILED"
				title="Erreur"
				message="La liste des agences n’a pas pu être chargée."
			/>
		</React.Fragment>
	);
};

export default FacilitiesNotifications;
